import { cbSafe } from "../lib/colourBlind";
// The client-side echo of backend/src/lib/passwordPolicy.ts: length is the
// rule (NIST SP 800-63B), not character classes. The breach check runs on the
// server; this only stops the obvious before a round trip.

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;

export function passwordLooksAcceptable(password: string): boolean {
  return password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH && !/^(.)\1+$/.test(password);
}

export function PasswordRules({ password, dark }: { password: string; dark?: boolean }) {
  const okColor = dark ? cbSafe("#8ef0c2") : "var(--c-successText)";
  const pendingColor = dark ? "#b49fd8" : "var(--c-subtle)";
  const rules: Array<[string, boolean]> = [
    [`At least ${PASSWORD_MIN_LENGTH} characters — a phrase of several words is easiest to remember`, password.length >= PASSWORD_MIN_LENGTH],
    ["Not a password that has appeared in a known data breach (checked when you save)", true],
  ];
  return (
    <ul style={{ margin: 0, paddingLeft: 18, fontSize: 11, lineHeight: 1.7 }}>
      {rules.map(([text, met]) => (
        <li key={text} style={{ color: met && password.length > 0 ? okColor : pendingColor }}>{text}</li>
      ))}
    </ul>
  );
}
